// extracted by mini-css-extract-plugin
export default {"image":"pfa-z","loaded":"qfa-z"};